import React, { useContext } from 'react'
import { AppContext } from '../../context/app'
import { withTheme } from 'theming'

const DescriptionModal = ({ text, onClose, theme }) => {
  const { isCustomTemplate } = useContext(AppContext)
  return (
    <div
      style={{ backgroundColor: isCustomTemplate ? `${theme.c1}80` : '#0a0a0a90' }}
      className={`justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none  `}
    >
      <div
        style={{ backgroundColor: `#25313E` }}
        className={`relative my-6 w-11/12 md:w-[691px] py-3 px-4 md:py-5 md:px-9 rounded-md md:rounded-[10px] `}
      >
        <p style={{ color: '#ffffff' }} className="md:text-lg font-semibold">
          Description
        </p>
        <p style={{ color: '#ffffff' }} className="text-[10px] md:text-xs mt-2.5">
          {text}
        </p>

        <div className="w-full flex justify-center items-center">
          <button
            onClick={onClose}
            className="text-white w-[100px] h-9 md:h-[44px] md:w-[142px] md:text-lg rounded-md flex items-center justify-center mt-4 md:mt-6"
            style={{ backgroundColor: '#ff6600' }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  )
}

export default withTheme(DescriptionModal)
